/**
 * File: /Users/tomasmuniesa/Documents/develop/nousmedis/syncwall/syncwall-frontend/src/app/base-animations.ts
 * Project: /Users/tomasmuniesa/Documents/develop/nousmedis/syncwall/syncwall-frontend
 * Created Date: Friday, October 27th 2023, 11:52:13 am
 * Author: Tomás
 * -----
 * Last Modified:  Friday, 27th October 2023 12:38:10 pm
 * Modified By: Tomás (tomas@cege.es>)
 * -----
 * Copyright (c) 2023 Nousmedis, CeGe
 * ------------------------------------
 * Javascript will save your soul!
 */


import {
    trigger,
    animate,
    transition,
    style,
    query
} from '@angular/animations';

export const fadeAnimation = trigger('fadeAnimation', [
    transition('* => *', [
        style({ opacity: 0 }),
        animate('0.5s', style({ opacity: 1 }))
    ])
]);

// --- fadeSlide: transición entre login-form y app-selector ---
// El elemento saliente sube con fade-out; el entrante baja con fade-in.
export const fadeSlide = trigger('fadeSlide', [
    transition(':enter', [
        style({ opacity: 0, transform: 'translateY(16px)' }),
        animate('320ms cubic-bezier(0.4, 0, 0.2, 1)',
            style({ opacity: 1, transform: 'translateY(0)' })
        ),
    ]),
    transition(':leave', [
        animate('220ms cubic-bezier(0.4, 0, 0.2, 1)',
            style({ opacity: 0, transform: 'translateY(-12px)' })
        ),
    ]),
]);
